// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7384":"2bf08dc6","8958":"2bf08dc6","9881":"2bf08dc6"}[chunkId] + ".chunk.css";
};